export default __webpack_public_path__ + "static/energy-7b083d5f7a08b8b8fecd8177172ed192.png";